import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Input } from '../../../../../../../components/Form'
import { SearchContainer } from './styles'
import api from 'services/api'
import { apiSearchIngredients } from '../../../domain/api'

type SearchComponentIngredientParams = {
  update: boolean
  ingredientName: string
  handleSelectIngredient: (
    id?: number,
    unitMeasure?: INGREDIENT_TYPES,
    ingredientName?: string
  ) => void
}

export function SearchComponentIngredient({
  update,
  ingredientName,
  handleSelectIngredient
}: SearchComponentIngredientParams) {
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState(false)
  const [ingredients, setIngredients] = useState<IIngredient[]>([])

  const getSearched = async (value: string) => {
    const response = await api.get(`${apiSearchIngredients()}?search=${value}`)

    setIngredients(response.data)
  }

  const timeOutId = useRef<NodeJS.Timeout>(null)

  const onSearchItem = useCallback(async (value: string) => {
    clearTimeout(timeOutId.current)
    timeOutId.current = setTimeout(() => getSearched(value), 500)
  }, [])

  useEffect(() => {
    if (ingredientName) {
      setSearch(ingredientName)
    }
  }, [ingredientName])

  return (
    <SearchContainer>
      <div>
        <Input
          label="Ingrediente"
          name={'ingredient_name'}
          id="option"
          onChange={({ target }) => {
            setSearch(target.value)
            setSelected(false)
            onSearchItem(target.value)
          }}
          rules={{ required: true }}
          value={search}
          fullControlled
          disabled={update}
        />
        <ul>
          {search !== '' &&
            !selected &&
            ingredients.map(item => (
              <li
                key={item.id}
                onClick={() => {
                  handleSelectIngredient(item.id, item.unit_measure, item.name)
                  setSearch(item.name)
                  setSelected(true)
                }}
              >
                {item.name}
              </li>
            ))}
        </ul>
      </div>
    </SearchContainer>
  )
}
